import { View } from "@react-pdf/renderer";
import {
  ResumePDFText,
  ProjectPDFLink,
  ResumePDFDescription,
} from "components/Resume/ResumePDF/common";
import { TemplateTwoPDFSection, TemplateTwoPDFSectionWithSubsections } from "./common";
import { ResumePDFIcon } from "components/Resume/ResumePDF/common/ResumePDFIcon";
import { styles, spacing } from "components/Resume/ResumePDF/styles";
import type { ResumeProject } from "lib/redux/types";

export const Project = ({
  heading,
  projects,
  themeColor,
  isPDF,
}: {
  heading: string;
  projects: ResumeProject[];
  themeColor: string;
  isPDF: boolean;
}) => {
  return (
    <TemplateTwoPDFSectionWithSubsections themeColor={themeColor} heading={heading}>
      {projects.map(
        ({ project, startDate, endDate, descriptions, projectLink }, idx) => (
          <View key={idx} wrap={false} style={{ ...styles.flexRow, ...(idx !== 0 ? { marginTop: "6pt" } : {}) }}>
            <View style={{ width: "30%", marginTop: "2pt" }}> {/* Reduced from spacing["0.5"] (6pt) to 2pt */}
              <ResumePDFText bold={true} style={{ lineHeight: "1.2" }}>
                {startDate && endDate
                  ? `${startDate} - ${endDate}`
                  : startDate || endDate}
              </ResumePDFText>
            </View>
            <View style={{ width: "70%", marginTop: "2pt" }}> {/* Reduced from spacing["0.5"] (6pt) to 2pt */}
              <View
                style={{
                  marginTop: "2pt", // Reduced from spacing["0.5"] (6pt) to 2pt
                }}
              >
                <View
                  style={{
                    ...styles.flexRow,
                    gap: "6pt", // Reduced from spacing["2"] (24pt) to 6pt
                  }}
                >
                  <ResumePDFText bold={true} style={{ lineHeight: "1.2" }}>
                    {project}
                  </ResumePDFText>
                  {projectLink && (
                    <ProjectPDFLink src={projectLink}>
                      <ResumePDFIcon
                        type="url"
                        isPDF={isPDF}
                        themeColor={themeColor}
                      />
                    </ProjectPDFLink>
                  )}
                </View>
              </View>
              <View style={{ ...styles.flexCol, marginTop: "3pt" }}> {/* Reduced from spacing["0.5"] (6pt) to 3pt */}
                <ResumePDFDescription items={descriptions} />
              </View>
            </View>
          </View>
        )
      )}
    </TemplateTwoPDFSectionWithSubsections>
  );
};
